GP.GPMod('ContentViewer',function(self){
    var vent   = null;
    var common = null;
    var _log   = null;

    var data = {
        // check and initialize a few params
        init: function() {
            vent   = self.vent;
            common = self.app.Util;
            _log   = self.app.Util.log;
        }
    };

    this.gallery = {};

    var gui = {
        init: function() {

        }
    };

    var apis = {
        get_content: function(model) {
            if (typeof model == 'undefined') {
                return;
            }

            let modal_data = {
                content_id: model.get('content_id'),
                duid: model.get('duid'),
                get_content: 1
            };

            if (GP.Util.check_location('/content/pictures') || GP.Util.check_location('/content/videos')) {
                modal_data.from_gallery = 1;
            }

            self.api.get('/members/content/viewer', {
                data: modal_data,
                success: function(json) {
                    // vent.trigger('ContentViewerLayout:destroy_modal');
                    var test_model = new GP.models.Content(json);
                    events.show_viewer(test_model);
                }
            });
        }
    };

    var handlers = {

    };

    var events = {
        init: function() {
            vent.on(self.moduleName+":setup_viewer", events.setup_viewer);
            vent.on(self.moduleName+":modal_direction", events.modal_direction);

            vent.on(self.moduleName+":show_content", events.show_content);
            GP.reqres.setHandler(self.moduleName+':get_gallery_collection', events.get_gallery_collection);
        },
        setup_binds: function() {
            // setup jquery selectors
            gui.init();
        },
        setup_viewer: function(content_id) {
            if (typeof(viewer_content) !== 'undefined') {
                self.gallery.is_gallery = false;
                self.gallery.media_set = false;
                var _gallery_pages = ['/user/profile', '/content/pictures', 'content/videos'];
                _.each(_gallery_pages, function(page) {
                    if (window.location.pathname.indexOf(page) != -1) {
                        self.gallery.is_gallery = true;
                    }
                });

                if (self.gallery.is_gallery) {
                    if (viewer_content.is_private && GP.Util.check_location('profile')) {
                        // Private
                        self.gallery.collection = GP.reqres.request('Content:get_private_collection');
                        self.gallery.load_more = 'Content:get_private_has_more';
                        self.gallery.load_more_trigger = 'Content:more_private_content';
                    } else if (GP.Util.check_location('profile')) {
                        self.gallery.collection = GP.reqres.request('Content:get_public_collection');
                        self.gallery.load_more = 'Content:get_profile_has_more';
                        self.gallery.load_more_trigger = 'Content:more_profile_content';
                    } else if (GP.Util.check_location('/content/pictures') || GP.Util.check_location('/content/videos')) {
                        self.gallery.collection = GP.Galleries.content_collection;
                        self.gallery.load_more = 'Galleries:get_has_more';
                        self.gallery.load_more_trigger = 'Galleries:more_content';
                        self.gallery.media_set = true;
                    }
                }

                content_model = new GP.models.Content(viewer_content);
                events.show_viewer(content_model);
            }
        },
        show_viewer: function(content_model) {
            vent.trigger('ContentViewerLayout:destroy_modal');

            if (content_model) {
                var layout = new self.app.views.ContentViewerLayout({
                    id: 'content-viewer',
                    model: content_model
                });

                $("#content-viewer-region").append(layout.el);
                layout.render();
            } else {
                // close the modal if we don't have a content model to show
                vent.trigger('Modal:close');
            }
        },
        modal_direction: function(current_content_id, direction) {
            var _content_model = self.gallery.collection.find(function(model){
                return model.get('content_id') == current_content_id;
            });

            var index = self.gallery.collection.indexOf(_content_model);

            if (direction == 'next') {
                events.modal_next(index);
            } else {
                events.modal_prev(index);
            }
        },
        modal_prev: function(current_index) {
            let new_index = (current_index == 0) ? self.gallery.collection.length - 1 : current_index - 1;

            if (self.gallery.media_set && current_index !== 0) {
                apis.get_content(self.gallery.collection.at(new_index));
            } else {
                events.show_viewer(self.gallery.collection.at(new_index));
            }
        },
        modal_next: function(current_index) {
            // if at last content, set index back to first
            let new_index = (current_index == self.gallery.collection.length - 1) ? 0 : current_index + 1;

            if (self.gallery.media_set) {
                apis.get_content(self.gallery.collection.at(new_index));
            } else {
                events.show_viewer(self.gallery.collection.at(new_index));
            }
        },
        trigger_viewer: function(model) {
            var modal_url = GP.Util.clean_url('/members/content/viewer/', {
                duid: model.get('duid'),
                content_id: model.get('content_id'),
            });

            GP.vent.trigger('Modal:open', {
                url: modal_url
            });
        },
        // adding a separate one for now (most likely can be combined with trigger/show viewer)
        show_content: function(content_id, duid) {
            var modal_url = GP.Util.clean_url('/members/content/viewer/', {
                content_id: content_id,
                duid: duid
            });
            vent.trigger('Modal:open', {
                url: modal_url
            });
        },
        get_gallery_collection: function() {
            return self.gallery.collection;
        }
    };

    this.addInitializer(function(){
        data.init();
        events.init();
    });
});
